import { defineStore } from 'pinia';
import camelcaseKeys from 'camelcase-keys';
import DealNotesAPI from 'dashboard/api/dealNotes';

const camelizeNote = data => camelcaseKeys(data || {}, { deep: true });

export const useDealNotesStore = defineStore('dealNotes', {
  state: () => ({
    records: {},
    uiFlags: {
      isFetching: false,
      isCreating: false,
      isDeleting: false,
    },
  }),

  getters: {
    getNotesByDealId: state => dealId => {
      const notes = state.records[dealId] || [];
      return notes.sort((a, b) => b.id - a.id);
    },
    getUIFlags: state => state.uiFlags,
  },

  actions: {
    async get(dealId) {
      this.uiFlags.isFetching = true;
      try {
        const { data } = await DealNotesAPI.get(dealId);
        this.records = {
          ...this.records,
          [dealId]: data.map(camelizeNote),
        };
      } catch (error) {
        throw new Error(error);
      } finally {
        this.uiFlags.isFetching = false;
      }
    },

    async create({ dealId, content }) {
      this.uiFlags.isCreating = true;
      try {
        const { data } = await DealNotesAPI.create(dealId, content);
        const dealNotes = this.records[dealId] || [];
        this.records[dealId] = [...dealNotes, camelizeNote(data)];
      } catch (error) {
        throw new Error(error);
      } finally {
        this.uiFlags.isCreating = false;
      }
    },

    async delete({ noteId, dealId }) {
      this.uiFlags.isDeleting = true;
      try {
        await DealNotesAPI.delete(dealId, noteId);
        const dealNotes = this.records[dealId] || [];
        this.records[dealId] = dealNotes.filter(note => note.id !== noteId);
      } catch (error) {
        throw new Error(error);
      } finally {
        this.uiFlags.isDeleting = false;
      }
    },
  },
});
